<template>
  <div>
    <header class="Header">
      <div class="Header__inner">
        <router-link to="/" class="Header_menu__logo Header_menu__logo--sm">
          <img class="Header_menu__logo_img" src="assets/img/melon_logo_blue.png" alt="MELON ONLINE">
        </router-link>
        <div class="Heade__main ">
          <div class="Header__menu_area Header__step_area">
            <div class="Step__box">
              <div class="Step__head">
                Step
              </div>
              <div v-for="step in 3" :key="step" class="Step__circle_line">
                <div
                  :class="`Step__circle ${stepSignUp === step ? 'Step__circle--active' : ''} ft_en`"
                  @click="changeStep(step)"
                >
                  <span>{{ step }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <slot />
    <the-footer />
  </div>
</template>
<script>
import TheFooter from '@/views/layouts/TheFooter'
import { mapState } from 'vuex'

export default {
  name: 'SignUpLayout',
  components: {
    TheFooter
  },
  computed: {
    ...mapState({
      stepSignUp: state => state.auth.currentStepSignUp
    })
  },
  created() {
    document.title = 'MELON'
  },
  methods: {
    changeStep(step) {
      this.$store.commit('auth/setStepSignUp', step)
    }
  }
}
</script>
